export default '/static/frontend/ReachDigital/12gobiking/dist/assets/bancontact-mister-cash-01de8b60.svg'